import React, { PureComponent } from 'react';

import * as styles from './search-path-hit.style';

type PathHitProps = {
  title: JSX.Element;
};

export default class SearchPathHit extends PureComponent<PathHitProps> {
  render() {
    return <styles.PathHit>{this.props.title}</styles.PathHit>;
  }
}
